import { Injectable } from '@angular/core';

import { map } from 'rxjs/operators';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './posted-flight.actions';
import * as fromPostedFlightQuery from './posted-flight.selectors';

@Injectable()
export class PostedFlightFacade {
  postedFlightSkeletonLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightSkeletonLoading)
  );
  postedFlightSkeletonLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightSkeletonLoaded)
  );
  postedFlightSkeleton$ = this.store.pipe(select(fromPostedFlightQuery.getPostedFlightSkeleton));

  postedFlightAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightAuditLoading)
  );
  postedFlightAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightAuditLoaded)
  );
  postedFlightAudit$ = this.store.pipe(select(fromPostedFlightQuery.getPostedFlightAudit));

  flightCrewMemberAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightCrewMemberAuditLoading)
  );
  flightCrewMemberAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightCrewMemberAuditLoaded)
  );
  flightCrewMemberAudit$ = this.store.pipe(select(fromPostedFlightQuery.getFlightCrewMemberAudit));

  flightBusinessPersonAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightBusinessPersonAuditLoading)
  );
  flightBusinessPersonAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightBusinessPersonAuditLoaded)
  );
  flightBusinessPersonAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightBusinessPersonAudit)
  );

  logbookApproachAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getLogbookApproachAuditLoading)
  );
  logbookApproachAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getLogbookApproachAuditLoaded)
  );
  logbookApproachAudit$ = this.store.pipe(select(fromPostedFlightQuery.getLogbookApproachAudit));

  flightPassengerAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightPassengerAuditLoading)
  );
  flightPassengerAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightPassengerAuditLoaded)
  );
  flightPassengerAudit$ = this.store.pipe(select(fromPostedFlightQuery.getFlightPassengerAudit));

  expenseAuditLoading$ = this.store.pipe(select(fromPostedFlightQuery.getExpenseAuditLoading));
  expenseAuditLoaded$ = this.store.pipe(select(fromPostedFlightQuery.getExpenseAuditLoaded));
  expenseAudit$ = this.store.pipe(select(fromPostedFlightQuery.getExpenseAudit));

  postedFlightEngineAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightEngineAuditLoading)
  );
  postedFlightEngineAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightEngineAuditLoaded)
  );
  postedFlightEngineAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightEngineAudit)
  );

  postedFlightComponentAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightComponentAuditLoading)
  );
  postedFlightComponentAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightComponentAuditLoaded)
  );
  postedFlightComponentAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightComponentAudit)
  );

  postedFlightFuelAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightFuelAuditLoading)
  );
  postedFlightFuelAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightFuelAuditLoaded)
  );
  postedFlightFuelAudit$ = this.store.pipe(select(fromPostedFlightQuery.getPostedFlightFuelAudit));

  postedFlightAdditionalDetailAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightAdditionalDetailAuditLoading)
  );
  postedFlightAdditionalDetailAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightAdditionalDetailAuditLoaded)
  );
  postedFlightAdditionalDetailAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightAdditionalDetailAudit)
  );

  oilFluidAuditLoading$ = this.store.pipe(select(fromPostedFlightQuery.getOilFluidAuditLoading));
  oilFluidAuditLoaded$ = this.store.pipe(select(fromPostedFlightQuery.getOilFluidAuditLoaded));
  oilFluidAudit$ = this.store.pipe(select(fromPostedFlightQuery.getOilFluidAudit));

  engineOilFluidAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getEngineOilFluidAuditLoading)
  );
  engineOilFluidAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getEngineOilFluidAuditLoaded)
  );
  engineOilFluidAudit$ = this.store.pipe(select(fromPostedFlightQuery.getEngineOilFluidAudit));

  componentOilFluidAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getComponentOilFluidAuditLoading)
  );
  componentOilFluidAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getComponentOilFluidAuditLoaded)
  );
  componentOilFluidAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getComponentOilFluidAudit)
  );

  postedFlightDeAntiIceAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightDeAntiIceAuditLoading)
  );
  postedFlightDeAntiIceAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightDeAntiIceAuditLoaded)
  );
  postedFlightDeAntiIceAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightDeAntiIceAudit)
  );

  postedFlightNotesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightNotesAuditLoading)
  );
  postedFlightNotesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightNotesAuditLoaded)
  );
  postedFlightNotesAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightNotesAudit)
  );

  fuelUpliftAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getFuelUpliftAuditLoading)
  );
  fuelUpliftAuditLoaded$ = this.store.pipe(select(fromPostedFlightQuery.getFuelUpliftAuditLoaded));
  fuelUpliftAudit$ = this.store.pipe(select(fromPostedFlightQuery.getFuelUpliftAudit));

  businessCategoryAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getBusinessCategoryAuditLoading)
  );
  businessCategoryAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getBusinessCategoryAuditLoaded)
  );
  businessCategoryAudit$ = this.store.pipe(select(fromPostedFlightQuery.getBusinessCategoryAudit));

  departmentAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getDepartmentAuditLoading)
  );
  departmentAuditLoaded$ = this.store.pipe(select(fromPostedFlightQuery.getDepartmentAuditLoaded));
  departmentAudit$ = this.store.pipe(select(fromPostedFlightQuery.getDepartmentAudit));

  logbookAuditLoading$ = this.store.pipe(select(fromPostedFlightQuery.getLogbookAuditLoading));
  logbookAuditLoaded$ = this.store.pipe(select(fromPostedFlightQuery.getLogbookAuditLoaded));
  logbookAudit$ = this.store.pipe(select(fromPostedFlightQuery.getLogbookAudit));

  crewMemberDutyAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getCrewMemberDutyAuditLoading)
  );
  crewMemberDutyAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getCrewMemberDutyAuditLoaded)
  );
  crewMemberDutyAudit$ = this.store.pipe(select(fromPostedFlightQuery.getCrewMemberDutyAudit));
  //Airframe landings/Engine cycles
  airFrameLandingsAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getAirFrameLandingsAuditLoadingSelector)
  );
  airFrameLandingsAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getAirFrameLandingsAuditLoadedSelector)
  );
  airFrameLandingsAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getAirFrameLandingsAuditSelector)
  );

  engineCyclesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getEngineCyclesAuditLoadingSelector)
  );
  engineCyclesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getEngineCyclesAuditLoadedSelector)
  );
  engineCyclesAudit$ = this.store.pipe(select(fromPostedFlightQuery.getEngineCyclesAuditSelector));

  //VOR Check Data audit
  vorcheckDataAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getVORCheckDataAuditLoadingSelector)
  );
  vorcheckDataAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getVORCheckDataAuditLoadedSelector)
  );
  vorcheckDataAudit$ = this.store.pipe(select(fromPostedFlightQuery.getVORCheckDataAuditSelector));

  //pre-flight checklist user e-signatures audit
  preFlightChecklistUserESignaturesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPreFlightChecklistUserESignaturesAuditLoading)
  );
  preFlightChecklistUserESignaturesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPreFlightChecklistUserESignaturesAuditLoaded)
  );
  preFlightChecklistUserESignaturesAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPreFlightChecklistUserESignaturesAudit)
  );

  //posted flight checklist user e-signatures audit
  postedFlightChecklistUserESignaturesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightChecklistUserESignaturesAuditLoading)
  );
  postedFlightChecklistUserESignaturesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightChecklistUserESignaturesAuditLoaded)
  );
  postedFlightChecklistUserESignaturesAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getPostedFlightChecklistUserESignaturesAudit)
  );

  //flight log user e-signatures audit
  flightLogUserESignaturesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightLogUserESignaturesAuditLoading)
  );
  flightLogUserESignaturesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightLogUserESignaturesAuditLoaded)
  );
  flightLogUserESignaturesAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getFlightLogUserESignaturesAudit)
  );

  //squawk user e-signatures audit
  squawkUserESignaturesAuditLoading$ = this.store.pipe(
    select(fromPostedFlightQuery.getSquawkUserESignaturesAuditLoading)
  );
  squawkUserESignaturesAuditLoaded$ = this.store.pipe(
    select(fromPostedFlightQuery.getSquawkUserESignaturesAuditLoaded)
  );
  squawkUserESignaturesAudit$ = this.store.pipe(
    select(fromPostedFlightQuery.getSquawkUserESignaturesAudit)
  );

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadPostedFlight() {
    this.store.dispatch(actions.ResetPostedFlight());
    this.store.dispatch(actions.LoadApproachTypes());
    this.store.dispatch(actions.LoadExpenseCategoryTypes());
    this.store.dispatch(actions.LoadPostedFlightSkeleton());
  }

  getApproachTypeName(approachTypeId: number) {
    return this.store.pipe(
      select(fromPostedFlightQuery.getApproachTypeName(approachTypeId)),
      map(r => (r ? r.name : ''))
    );
  }

  getExpenseCategoryTypeName(expenseCategoryTypeId: number) {
    return this.store.pipe(
      select(fromPostedFlightQuery.getExpenseCategoryTypeName(expenseCategoryTypeId)),
      map(r => (r ? r.name : ''))
    );
  }

  loadLegDetailAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightAudit({ postedFlightId }));
  }

  loadNextLegDetailAuditPage(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightAudit({ postedFlightId }));
  }

  loadFlightCrewMemberAudit(flightCrewMemberId: number) {
    this.store.dispatch(actions.LoadFlightCrewMemberAudit({ flightCrewMemberId }));
  }

  loadNextPageFlightCrewMemberAuditPage(flightCrewMemberId: number) {
    this.store.dispatch(actions.LoadNextPageFlightCrewMemberAudit({ flightCrewMemberId }));
  }

  loadFlightBusinessPersonAudit(flightBusinessPersonId: number) {
    this.store.dispatch(actions.LoadFlightBusinessPersonAudit({ flightBusinessPersonId }));
  }

  loadNextPageFlightBusinessPersonAudit(flightBusinessPersonId: number) {
    this.store.dispatch(actions.LoadNextPageFlightBusinessPersonAudit({ flightBusinessPersonId }));
  }

  loadLogbookApproachAudit(logbookApproachId: number) {
    this.store.dispatch(actions.LoadLogbookApproachAudit({ logbookApproachId }));
  }

  loadNextPageLogbookApproachAudit(logbookApproachId: number) {
    this.store.dispatch(actions.LoadNextPageLogbookApproachAudit({ logbookApproachId }));
  }

  loadFlightPassengerAudit(flightPassengerId: number) {
    this.store.dispatch(actions.LoadFlightPassengerAudit({ flightPassengerId }));
  }

  loadNextPageFlightPassengerAudit(flightPassengerId: number) {
    this.store.dispatch(actions.LoadNextPageFlightPassengerAudit({ flightPassengerId }));
  }

  loadExpenseAudit(expenseId: number) {
    this.store.dispatch(actions.LoadExpenseAudit({ expenseId }));
  }

  loadNextPageExpenseAudit(expenseId: number) {
    this.store.dispatch(actions.LoadNextPageExpenseAudit({ expenseId }));
  }

  loadPostedFlightEngineAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadPostedFlightEngineAudit({ postedFlightEngineId }));
  }

  loadNextPagePostedFlightEngineAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightEngineAudit({ postedFlightEngineId }));
  }

  loadPostedFlightComponentAudit(postedFlightComponentId: number) {
    this.store.dispatch(actions.LoadPostedFlightComponentAudit({ postedFlightComponentId }));
  }

  loadNextPagePostedFlightComponentAudit(postedFlightComponentId: number) {
    this.store.dispatch(
      actions.LoadNextPagePostedFlightComponentAudit({ postedFlightComponentId })
    );
  }

  loadPostedFlightFuelAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightFuelAudit({ postedFlightId }));
  }

  loadNextPagePostedFlightFuelAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightFuelAudit({ postedFlightId }));
  }

  loadPostedFlightAdditionalDetailAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightAdditionalDetailAudit({ postedFlightId }));
  }

  loadNextPagePostedFlightAdditionalDetailAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightAdditionalDetailAudit({ postedFlightId }));
  }

  loadOilFluidAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadOilFluidAudit({ postedFlightId }));
  }

  loadNextPageOilFluidAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageOilFluidAudit({ postedFlightId }));
  }

  loadEngineOilFluidAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadEngineOilFluidAudit({ postedFlightEngineId }));
  }

  loadNextPageEngineOilFluidAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadNextPageEngineOilFluidAudit({ postedFlightEngineId }));
  }

  loadComponentOilFluidAudit(postedFlightComponentId: number) {
    this.store.dispatch(actions.LoadComponentOilFluidAudit({ postedFlightComponentId }));
  }

  loadNextPageComponentOilFluidAudit(postedFlightComponentId: number) {
    this.store.dispatch(actions.LoadNextPageComponentOilFluidAudit({ postedFlightComponentId }));
  }

  loadPostedFlightDeAntiIceAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightDeAntiIceAudit({ postedFlightId }));
  }

  loadNextPagePostedFlightDeAntiIceAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightDeAntiIceAudit({ postedFlightId }));
  }

  loadPostedFlightNotesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightNotesAudit({ postedFlightId }));
  }

  loadNextPagePostedFlightNotesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPagePostedFlightNotesAudit({ postedFlightId }));
  }

  loadFuelUpliftAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadFuelUpliftAudit({ postedFlightId }));
  }

  loadNextPageFuelUpliftAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageFuelUpliftAudit({ postedFlightId }));
  }

  loadBusinessCategoryAudit(flightId: number) {
    this.store.dispatch(actions.LoadBusinessCategoryAudit({ flightId }));
  }

  loadNextPageBusinessCategoryAudit(flightId: number) {
    this.store.dispatch(actions.LoadNextPageBusinessCategoryAudit({ flightId }));
  }

  loadDepartmentAudit(flightId: number) {
    this.store.dispatch(actions.LoadDepartmentAudit({ flightId }));
  }

  loadNextPageDepartmentAudit(flightId: number) {
    this.store.dispatch(actions.LoadNextPageDepartmentAudit({ flightId }));
  }

  loadLogbookAudit(logbookId: number) {
    this.store.dispatch(actions.LoadLogbookAudit({ logbookId }));
  }

  loadNextPageLogbookAudit(logbookId: number) {
    this.store.dispatch(actions.LoadNextPageLogbookAudit({ logbookId }));
  }

  loadCrewMemberDutyAudit(crewMemberDutyId: number) {
    this.store.dispatch(actions.LoadCrewMemberDutyAudit({ crewMemberDutyId }));
  }

  loadNextPageCrewMemberDutyAudit(crewMemberDutyId: number) {
    this.store.dispatch(actions.LoadNextPageCrewMemberDutyAudit({ crewMemberDutyId }));
  }

  loadAirFrameLandingsAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadAirFrameLandingsAuditAction({ postedFlightId }));
  }

  loadNextPageAirFrameLandingsAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageAirFrameLandingsAuditAction({ postedFlightId }));
  }

  loadEngineCyclesAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadEngineCyclesAuditAction({ postedFlightEngineId }));
  }

  loadNextPageEngineCyclesAudit(postedFlightEngineId: number) {
    this.store.dispatch(actions.LoadNextPageEngineCyclesAuditAction({ postedFlightEngineId }));
  }

  loadVORCheckDataAudit(aircraftProfileId: number) {
    this.store.dispatch(actions.LoadVORCheckDataAuditAction({ aircraftProfileId }));
  }

  loadNextPageVORCheckDataAudit(aircraftProfileId: number) {
    this.store.dispatch(actions.LoadNextPageVORCheckDataAuditAction({ aircraftProfileId }));
  }

  loadPreFlightChecklistUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPreFlightChecklistUserESignaturesAudit({ postedFlightId }));
  }

  loadNextPagePreFlightChecklistUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(
      actions.LoadNextPagePreFlightChecklistUserESignaturesAudit({ postedFlightId })
    );
  }

  loadPostedFlightChecklistUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadPostedFlightChecklistUserESignaturesAudit({ postedFlightId }));
  }

  loadNextPagePostedFlightChecklistUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(
      actions.LoadNextPagePostedFlightChecklistUserESignaturesAudit({ postedFlightId })
    );
  }

  loadFlightLogUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadFlightLogUserESignaturesAudit({ postedFlightId }));
  }

  loadNextPageFlightLogUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageFlightLogUserESignaturesAudit({ postedFlightId }));
  }

  loadSquawkUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadSquawkUserESignaturesAudit({ postedFlightId }));
  }

  loadNextPageSquawkUserESignaturesAudit(postedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageSquawkUserESignaturesAudit({ postedFlightId }));
  }
}
